import { Avatar, Box, FormLabel, Typography } from "@mui/material";
import WallpaperIcon from "@mui/icons-material/Wallpaper";
import styled from "@emotion/styled";

const CustomAvatar = styled(Avatar)`
  width: 100%;
  height: auto;
  min-height: 150px;
  max-height: 256px;
  margin-bottom: 1rem;
  margin-top: 0.125rem;
  background-color: ${(p) => p.theme.colors.background2};

  svg {
    font-size: 3.5rem;
    color: ${(p) => p.theme.text.colors.primary};
  }

  & img {
    object-fit: contain;
  }
`;

type ImagePreviewFieldProps = {
  label: string;
  imageSrc?: string | null;
  alt?: string;
  helperText?: string;
  aspectRatio?: number;
  placeholderIcon?: React.ReactNode;
};

export function ImagePreviewField({
  label,
  imageSrc,
  alt,
  helperText,
  aspectRatio,
  placeholderIcon,
}: ImagePreviewFieldProps) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
      <FormLabel>{label}</FormLabel>
      <CustomAvatar
        alt={alt ?? ""}
        src={imageSrc ?? ""}
        variant="rounded"
        sx={{ aspectRatio }}
      >
        {placeholderIcon ?? <WallpaperIcon fontSize="large" />}
      </CustomAvatar>
      {!!helperText && (
        <Typography variant="body2" textAlign={"center"}>
          {helperText}
        </Typography>
      )}
    </Box>
  );
}
